<template>
  <div>
    <!-- 顶部banner -->
    <banner :image="require(`@/assets/solution/banner2.jpg`)"  :fontText="fontText" />
    <!-- 一 -->
    <div class="floor-retail floor-tab-height840">
      <div data-aos="fade-up">
        <div>
          <div class="title">
            全渠道零售的必要性及优势
          </div>
        </div>
        <div class="retailForEach">
          <div v-for="(item,index) in retailList" :key="index" class="retail-item-one">
            <img :src="item.icon" alt="">
            <div class="retail-item-one-title">{{item.title}}</div>
            <div class="retail-item-one-content">{{item.content}}</div>
          </div>
        </div>
        <div class="industry-container">
          <img src="@/assets/solution/retailIOne.jpg" alt="" />
        </div>
      </div>
      
    </div>
    <!-- 二 -->
    <div class="floor-retail floor-tab-height750">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            覆盖线上线下全渠道场景
          </div>
        </div>
        <div class="industry-container" data-aos="fade-up">
          <img src="@/assets/solution/retailITwo.jpg" alt="" />
        </div>
      </div>
      
    </div>
    <!-- 三 -->
    <div class="floor-retail-bg floor-tab-height">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            核心能力
          </div>
        </div>
        <div class="retail-content" data-aos="fade-up">
          <div v-for="(item,index) in retailTwoList" :key="index" class="retail-item-two">
            <div class="retail-two-title">{{item.title}}</div>
            <div v-for="(ele,idex) in item.content" :key="idex" class="retail-child-content" :style="{marginTop: index === 3 && idex===1? '-18px' : ''}">
                <img :src="ele.icon" alt="" />
                  <div>
                    <div class="retail-child-title">{{ele.title}}</div>
                    <div class="retail-content-child-content">{{ele.content}}</div>
                  </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <!-- 四 -->
    <div class="floor-retail floorColor floor-tab-height950">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            平台架构
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            功能板块全景：承上启下，支持新渠道/新品牌扩展，以及供应链能力延伸
          </div>
        </div>
        <div class="industry-container" data-aos="fade-up">
          <img src="@/assets/solution/retailIThr.png" alt="" />
        </div>
      </div>
      
    </div>
    <!-- 五 -->
    <div class="floor-retail-bg bg2">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            订单智能管理
          </div>
          <div style="font-size: 16px; color: #fff; line-height: 21px;opacity: 0.7;">
            全渠道订单收订、快速进行订单审核和分仓处理。根据收货区域自动匹配物流和仓库 <br/>支持O2O应用，线上支付、门店自提和远程配送
          </div>
        </div>
        <div data-aos="fade-up">
          <div class="retailForEach">
            <div v-for="(item,index) in retailThrList" :key="index" class="retail-item-one" style="height: 310px">
              <img :src="item.icon" alt="">
              <div class="retail-item-one-title">{{item.title}}</div>
              <div class="retail-item-two-content">
                <div v-for="(ele,idex) in item.content" :key="idex" class="retail-child-item">
                  <img src="@/assets/solution/correctIcon2.png" alt="">
                  <div class="retail-item-two-font">{{ele}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="industry-container">
            <img src="@/assets/solution/retailIFour.png" alt="" />
          </div>
        </div>
        
        <div class="industry-container" data-aos="fade-up">
          <img src="@/assets/solution/retailIFive.png" alt="" />
        </div>
      </div>
      
    </div>
    <!-- 六 -->
    <div class="floor-retail floor-tab-height750">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            完善的开放平台能力
          </div>
        </div>
        <div class="financial-container-two" data-aos="fade-up">
          <img src="@/assets/solution/retailISix.png" alt="" />
          <div class="financial-content-two">
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">高度灵活性</div>
                <div class="financial-item-content">允许企业能够快速适应市场变化和第三方平台政策的调整。这种灵活性确保企业能够及时响应外部变化，因为新的政策调整或功能需求可以通过模块化的方式快速集成，保障经营效率</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">扩展性和可维护性</div>
                <div class="financial-item-content">充分考虑了未来的扩展性，不仅支持现有平台简单配置后的快速接入，还能够容纳未来新兴平台，节省了大量的开发成本和时间</div>
              </div>
            </div>
            <div class="financial-content-item-two">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">促进生态系统建设</div>
                <div class="financial-item-content">鼓励第三方开发者和合作伙伴参与到平台的生态建设中来，从而丰富了服务和产品的生态系统。这种协作可以带来更多的创新和价值创造</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 七 -->
    <floorTwo :retailArr="retailArr"/>
    <Footer/>
  </div>
</template>
<script>
import Footer from '../../components/Footer'
import banner from './components/banner'
import floorTwo from './components/floor2'

export default {
  name: "retail",
  components: {
    floorTwo,
    Footer,
    banner
  },
  data() {
    return {
      fontText: {
        title: '全渠道零售解决方案',
        txtMiddle: [
          '全渠道全触点的品牌电商系统',
          '实现企业多渠道一体化电商运营模式'
        ]
      },
      retailList: [
        {
          icon: require("@/assets/solution/retailIcon1.png"),
          title: '订单智能路由分配',
          content: '随着互联网和移动设备的普及，消费者越来越依赖线上购物。同时，线下实体店也在不断进行数字化转型，以适应这一趋势。'
        },
        {
          icon: require("@/assets/solution/retailIcon2.png"),
          title: '消费者行为变化',
          content: '消费者越来越注重购物体验，希望在任何渠道都能获得一致、便捷的服务。'
        },
        {
          icon: require("@/assets/solution/retailIcon3.png"),
          title: '市场竞争',
          content: '全渠道零售是应对市场竞争的一种策略，通过整合线上线下资源，提高品牌影响力和市场份额。'
        }
      ],
      retailTwoList: [
        {
          title: '跨渠道库存管理',
          content: [
            {
              icon: require("@/assets/solution/retailCoreIcon1.png"),
              title: '库存信息管理',
              content: '各销售渠道的库存信息实时更新，避免库存积压或缺货现象'
            },
            {
              icon: require("@/assets/solution/retailCoreIcon2.png"),
              title: '智能调度',
              content: '根据销售数据和库存情况，自动调整各渠道的库存分配，提高库存周转率'
            },
            {
              icon: require("@/assets/solution/retailCoreIcon3.png"),
              title: '订单优先级',
              content: '根据订单的紧急程度、商品价值等因素，合理安排订单的发货顺序'
            },
          ]
        },
        {
          title: '订单和运输的同步',
          content: [
            {
              icon: require("@/assets/solution/retailCoreIcon4.png"),
              title: '订单自动处理',
              content: '实现订单的自动化处理，减少人工操作失误'
            },
            {
              icon: require("@/assets/solution/retailCoreIcon5.png"),
              title: '智能分单',
              content: '根据客户地址、商品属性等因素，自动分配最优的物流渠道和配送地址'
            },
            {
              icon: require("@/assets/solution/retailCoreIcon6.png"),
              title: '订单跟踪',
              content: '提供订单状态实时查询服务，方便客户了解订单的配送情况'
            },
          ]
        },
        {
          title: '客户信息的共享和整合',
          content: [
            {
              icon: require("@/assets/solution/retailCoreIcon7.png"),
              title: '客户信息整合',
              content: '各渠道的客户信息整合到一个管理系统中，方便统一管理和分析'
            },
            {
              icon: require("@/assets/solution/retailCoreIcon8.png"),
              title: '个性化推荐',
              content: '根据客户的历史购买记录和喜好，提供个性化的商品推荐服务'
            },
            {
              icon: require("@/assets/solution/retailCoreIcon9.png"),
              title: '客户关怀',
              content: '通过多种渠道与客户保持沟通，提高客户满意度'
            },
          ]
        },
        {
          title: '统一的客户服务体验',
          content: [
            {
              icon: require("@/assets/solution/retailCoreIcon10.png"),
              title: '客服渠道整合',
              content: '将各渠道的客服渠道(如官方网站、社交媒体、电话等)进行整合，提供一致的服务标准和服务流程'
            },
            {
              icon: require("@/assets/solution/retailCoreIcon11.png"),
              title: '快速响应',
              content: '具备24/7的在线客服，快速响应并解决客户的问题和投诉'
            },
            {
              icon: require("@/assets/solution/retailCoreIcon12.png"),
              title: '满意度调查',
              content: '定期推送客户满意度调查数据不断优化客户服务体验'
            },
          ]
        },
      ],
      retailThrList: [
        {
          icon: require("@/assets/solution/tabTwoIcon4.png"),
          title: '订单智能路由分配',
          content: [
            '就近原则：提升消费者体验，自提优先',
            '库存深度优先原则：保障线下品类齐全',
            '订单拆分原则：以消费者体验最优为核心，时效最快'
          ]
        },
        {
          icon: require("@/assets/solution/retailIcon3.png"),
          title: '门店响应时效',
          content: [
            '门店接待优先：可并发处理量',
            '门店基础条件',
            '客服与门店沟通机制',
            '门店拒绝管理',
            '超时熔断机制：无响应兜底方案'
          ]
        },
        {
          icon: require("@/assets/solution/tabTwoIcon5.png"),
          title: '门店自提与及时快递',
          content: [
            '标准化准备周期',
            '响应配合机制',
            '最近门店自提优先',
            '商城针对及时快递规则'
          ]
        }
      ],
      retailArr: {
        title: '赋能运营，解锁增长新潜能',
        text: '通过全面提升运营效能、精准适应电商平台规则、强化企业政策执行力，为零售商构建了一个高效、智能、统一管理的全渠道生态体系',
        height: '460px',
        solutionList:[
          {
            image: require("@/assets/solution/numFour.png"),
            title: '全面提升渠道效能',
            content: '通过整合线上线下的所有销售渠道，实现资源的优<br/>化配置与协同管理，无论是在实体店铺、自建电商<br/>平台、第三方市场平台，还是社交媒体等新兴渠<br/>道，都能够显著提升运营效率。<br/>这一整合不仅简化了跨渠道管理的复杂性，还确保<br/>了各渠道间无缝衔接，提升了顾客体验的一致性。',
          },
          {
            image: require("@/assets/solution/numFive.png"),
            title: '深度优化电商平台策略',
            content: '针对不同的电商平台，深入研究并适应其独特规则<br/>与算法，包括商品命名策略、关键词优化、搜索排<br/>名提升等，以确保产品能在众多竞争者中脱颖而<br/>出，更容易被潜在顾客发现。<br/>这种精细化运营策略极大提升了商品的可见度和点<br/>击率，有效转化为销售增长。',
          },
          {
            image:require("@/assets/solution/numSix.png"),
            title:'强化企业政策执行力与一致性',
            content:'赋予企业更强的中央管控能力，确保在多渠道布局<br/>中，运营活动、价格策略、库存管理、客户服务等<br/>均能紧密遵循公司的统一政策。<br/>有效减少了因政策不一致带来的混乱，还保证了品<br/>牌形象与服务质量的一致性，增强了消费者的信任<br/>与忠诚度。',
          },
        ],
      },
    };
  },
  methods: {
    // 当鼠标进入元素时触发
    // handleMouseEnter(index) {
    //   // console.log('鼠标进入了元素' + index);
    //   this.industrySelecedIndex = index;
    // },
    // 当鼠标离开元素时触发
    // handleMouseLeave(index) {
    //   // console.log('鼠标离开了元素');
    // },
  },
};
</script>

<style lang="less" scoped>
.floor-retail {
  width: 100%;
  height: 920px;
  background: #fff;
}
.floor-retail .title{
  font-weight: bold; font-size: 32px; color: #222222;padding-top: 80px;margin-bottom: 14px;
}
.floor-retail .retailForEach{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.floor-retail-bg .retailForEach{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.retail-item-one{
  width: 380px;
  height: 240px;
  margin: auto;
  background: linear-gradient(180deg, #FAFCFF, #ECF2FF);
  border-radius: 6px;
}

.retail-item-one img{
  width: 40px;
  height: 40px;
  margin-top: 30px;
  margin-bottom: 18px;
}
.retail-item-one-title{
  font-size: 18px;
  color: #222222;
  font-weight: bold;
  margin-bottom: 21px;
}
.retail-item-one-content{
  padding: 0 50px;
  color: #595859;
  font-size: 14px;
  line-height: 22px;
}
.retail-child-item{
  display: flex;
  text-align: left;
  /* align-items: self-end; */
  margin-bottom: 10px;
}
.retail-child-item img{
  width: 16px;
  height: 16px;
  margin: 0;
}
.retail-item-two-font{
  margin-left: 10px;
  font-size: 14px;
}
.retail-item-two-content{
  width: 280px;
  margin: auto;
}
.floor-retail .industry-container{
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-retail .industry-container img{
  width: 100%;
}

.floorColor{
  background: #F4F5FB;
}
.floor-retail-bg{
  width: 100%;
  height: 950px;
  background: url('../../assets/solution/floorBg3.png') no-repeat center center;
  background-size: 1920px 100%;
  background-color: #0B4FD1;
}
.bg2{
  background: url('../../assets/solution/floorBg3.png') no-repeat center center;
  background-size: 1980px 100%;
  background-color: #0B4FD1;
  height: 1300px;
}
.retail-content{
  margin: auto;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 40px;
}
.retail-item-two{
  background: url('../../assets/solution/retailI-bg.png');
  width: 590px;
  height: 350px;
  background-size: 100% 100%;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 40px;
}
.retail-two-title{
  text-align: left;
  color: #0C53C9;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
}
.retail-child-content{
  text-align: left;
  display: flex;
}
.retail-child-content img{
  width: 32px;
  height: 32px;
  margin-right: 10px;
}
.retail-child-title{
  color: #222222;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 6px;
  margin-top: 4px;
}
.retail-content-child-content{
  color: #595859;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 28px;
}
.floor-retail-bg .industry-container{
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-retail-bg .industry-container img{
  width: 100%;
}
.floor-retail-bg  .title{
  font-weight: bold; font-size: 32px; color: #FFFFFF;padding-top: 80px;margin-bottom: 14px;
}
.floor-tab-height{
  height: 1000px;
}
.floor-tab-height840{
  height: 840px;
}
.floor-tab-height750{
  height: 750px;
}
.floor-tab-height950{
  height:950px;
}
.financial-container img{
  width: 600px;
  height: 480px;
}
.financial-container-two{
  width: 1200px;
  margin: auto;
  margin-top: 45px;
  display: flex;
  justify-content: space-between;
}
.financial-container-two img{
  width: 620px;
  height: 480px;
}
.financial-content-two{
  width: 520px;
  margin-top: 38px;
}
.financial-content-item-two{
  text-align: left;
  display: flex;
  margin-bottom: 10px;
}
.financial-content-item-two img{
  width: 22px;
  height: 16px;
  margin-top: 8px;
  margin-right: 10px;
}
.financial-content-title{
  color: #222222;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 14px;
}
.financial-item-content{
  color: #595859;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 36px;
}
</style>
